import type { ChangeTemplateSourceCommandData } from '@festina/life-general-types/life'
import { typeUtils } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import { useHook } from '../../lenteHooks'
import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'
import { LifeLazyForm } from '../forms/LifeLazyForm'
import { initialFormEntriesFromVBase } from '../forms/yup/validation/yupValidationUtils'
import { LifeInput } from '../inputs/LifeInput'

const validateKey = typeUtils.createValidator<ChangeTemplateSourceCommandData>()

export const ChangeTemplateSourceForm = (
  props: CommandDataFormProps<ChangeTemplateSourceCommandData>,
) => {
  const translate = useTranslate()

  const { tenantId, employerAgreementId } = useHook(
    'routing.employer.useEmployerAgreementParams',
  )()

  const fetchFrame = useHook(
    'lazyFetchers.life.useLazyFetchChangeTemplateSourceFrame',
  )({ tenantId, employerAgreementId })

  return (
    <LifeLazyForm
      mapInitialValues={(frame): ChangeTemplateSourceCommandData => ({
        _type: 'ChangeTemplateSourceCommandData',
        ...initialFormEntriesFromVBase(frame),
      })}
      fetchFrame={fetchFrame}
      {...props}
    >
      <LifeInput
        fallbackInputType="string"
        name={validateKey('applyDate')}
        label={translate('changeTemplateSource.input.applyDate')}
      />
      <LifeInput
        fallbackInputType="string"
        name={validateKey('templateSourceId')}
        label={translate('changeTemplateSource.input.templateSourceId')}
      />
    </LifeLazyForm>
  )
}
